import React from 'react'
import { Paragraph } from '@cobalt/cobalt-react-components'
import { object, bool } from 'prop-types'
import {
  PASSWORD_POLICIES_LIST_CHARACTER,
  PASSWORD_POLICIES_TITLE,
  PASSWORD_POLICIES_NUMBER_OF_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS,
  PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS,
  PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS
} from '../../constants/ui.labels'
import '../../../assets/password-policies.css'

class PasswordPolicies extends React.PureComponent {
  renderParagraph = text =>
    this.props.isError ? (
      <Paragraph>{PASSWORD_POLICIES_LIST_CHARACTER.concat(text)}</Paragraph>
    ) : (
      <Paragraph microcopy>{text}</Paragraph>
    )

  render() {
    const { isError, passwordPolicies } = this.props
    return (
      <div className={isError ? undefined : 'password-policies'}>
        <React.Fragment>
          {isError ? <Paragraph>{PASSWORD_POLICIES_TITLE}</Paragraph> : null}
          {this.renderParagraph(
            PASSWORD_POLICIES_NUMBER_OF_CHARACTERS(passwordPolicies.minLength)
          )}
          {this.renderParagraph(
            PASSWORD_POLICIES_NUMBER_OF_UPPER_CASE_CHARACTERS(
              passwordPolicies.minUpper
            )
          )}
          {this.renderParagraph(
            PASSWORD_POLICIES_NUMBER_OF_LOWER_CASE_CHARACTERS(
              passwordPolicies.minLower
            )
          )}
          {this.renderParagraph(
            PASSWORD_POLICIES_MIN_NUMBERS_CHARACTERS(passwordPolicies.minDigits)
          )}
          {this.renderParagraph(
            PASSWORD_POLICIES_NUMBER_OF_SPECIAL_CHARACTERS(
              passwordPolicies.minSpecial
            )
          )}
        </React.Fragment>
      </div>
    )
  }
}

PasswordPolicies.propTypes = {
  isError: bool,
  passwordPolicies: object
}

PasswordPolicies.defaultProps = {
  isError: false
}

export default PasswordPolicies
